module.exports = __webpack_public_path__ + "static/media/engage.b7ec8881.svg";